// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"150":"00462d16","284":"59f1af39","440":"20b06b22","446":"8295c5cb","506":"aff32cf9","600":"a68bb3e6","816":"50a422d8"}[chunkId] + ".js";
};